import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { AlertColor } from '@mui/material'

export interface NotificationState {
  open?: boolean
  type?: AlertColor
  message?: string | React.ReactNode
  timeout?: number | null
}

export const notificationInitialState: NotificationState = {
  open: false,
  type: 'info',
  message: '',
  timeout: 5000,
}

export const NotificationSlice = createSlice({
  name: 'notification',
  initialState: notificationInitialState,
  reducers: {
    addNotification: (state, action: PayloadAction<NotificationState>) => ({
      ...notificationInitialState,
      ...action.payload,
      open: true,
    }),
    clearNotification: state => ({ ...state, open: false }),
  },
})

export const NotificationActions = NotificationSlice.actions
export const NotificationReducer = NotificationSlice.reducer
